import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    standalone: false
})
export class ToastComponent {
  @Input() isError: boolean = false;
  @Input() message: string = 'Sua mensagem aqui';
}
